import { useAuth } from '@backoffice-frontend/authentication'
import {
  ExpanderTile,
  Input,
  InputAdornment,
} from '@backoffice-frontend/patterns'
import { CopyIcon } from '@moia-dev/pace-icons'
import { IconButton } from '@moia-dev/pace-web'
import { jwtDecode } from 'jwt-decode'
import { useTranslation } from 'react-i18next'

export const IdTokenTile = () => {
  const { t } = useTranslation()
  const { token } = useAuth()
  const idToken = token ?? ''

  return (
    <ExpanderTile
      dataTestId="idToken"
      loading={false}
      heading={t('authenticatedAppView_cognitoToken_header')}
    >
      <Input
        type="text"
        disabled
        fullWidth
        value={idToken}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              size="compact"
              onClick={() => {
                console.info(jwtDecode(idToken))
                void navigator.clipboard.writeText(idToken)
              }}
              icon={<CopyIcon />}
              variant="plain"
            />
          </InputAdornment>
        }
      />
    </ExpanderTile>
  )
}
